import type { SalesDataPoint } from "@fero/hooks";
import { useMemo } from "react";
import { formatYearMonthToMonthName } from "utils/date-utils";
import { salesChartConfig } from "./chart-configs";
import { padChartDataWithEmptyMonths } from "./chart-data-utils";
import { DashboardUnifiedChart } from "./dashboard-unified-chart";

interface Props {
  data: SalesDataPoint[] | undefined;
  title?: string;
  monthsToShow?: number;
}

export const SalesChart = ({ data, title, monthsToShow = 12 }: Props) => {
  // Pad the data to ensure consistent bar widths
  const paddedData = useMemo(() => {
    if (!data) return [];
    return padChartDataWithEmptyMonths(data, monthsToShow);
  }, [data, monthsToShow]);

  return (
    <DashboardUnifiedChart
      title={title || salesChartConfig.title}
      data={paddedData}
      series={salesChartConfig.series}
      barCategoryGap={salesChartConfig.barCategoryGap}
      xAxisKey="month"
      xAxisFormatter={formatYearMonthToMonthName}
    />
  );
};
